import { FieldNamesByFormModel } from '@crm-framework/types';

import { IRequestModel } from './models';

export const FORM_FIELDS: FieldNamesByFormModel<IRequestModel> = {
  shopId: 'shopId',
  secretKey: 'secretKey',
  amount: 'amount',
  currency: 'currency',
  cardNumber: 'cardNumber',
  description: 'description',
};

export const COMMON_REQUIRED_FIELDS = Object.keys(FORM_FIELDS);
